import StudentInfo from "./StudentInfo";

export default StudentInfo;
